import { HandHeart, ArrowRight } from "lucide-react";
import { Reveal, Chapter, IMAGES, scrollToId } from "@/components/Shared";

const Scholarships = () => (
  <section id="scholarships" data-testid="scholarships-section" className="relative bg-deepteal py-24 sm:py-32 overflow-hidden">
    <div className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full bg-amber-400/10 blur-3xl" />
    <div className="pointer-events-none absolute bottom-0 right-0 h-80 w-80 rounded-full bg-coral/10 blur-3xl" />
    <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
      <div>
        <Reveal>
          <Chapter num="04" label="Tuition Support" light />
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.12] text-amber-50">
            Child Care Scholarships <em className="italic text-amber-300">Accepted</em>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-amber-100/85">
            Pieces to Our Puzzle Childcare accepts eligible child care scholarship assistance.
            Quality childcare in Halethorpe should be within reach for every family — we encourage
            you to contact us to discuss enrollment and payment options.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-amber-100/60">
            Please note: scholarship eligibility and approval are determined by the applicable
            program. Contact us and we'll gladly talk through how scholarship assistance may apply
            to your family's enrollment.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <button
            data-testid="scholarships-cta"
            onClick={() => scrollToId("#contact")}
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-amber-400 px-7 py-3.5 text-sm font-bold text-deepteal-dark shadow-xl shadow-amber-500/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-amber-300"
          >
            <HandHeart className="h-4 w-4" />
            Ask About Scholarships
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="overflow-hidden rounded-3xl border-4 border-amber-100/15 shadow-2xl">
          <img
            src={IMAGES.play}
            alt="Children learning together — child care scholarships accepted at Halethorpe MD childcare"
            className="h-80 sm:h-[420px] w-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="absolute -bottom-5 left-6 rounded-2xl bg-parchment px-6 py-4 shadow-xl border border-amber-900/10">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-800">
            Child care scholarships accepted
          </p>
          <p className="font-serif text-lg text-deepteal-dark mt-1">Let's talk about your options</p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Scholarships;
